import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  totalNotification: 0,
  savechanges: true,
  listNotification: [],
};

export const oldDataSlice = createSlice({
  name: "oldData",
  initialState,
  reducers: {
    savechanges: (state, action) => {
      state.savechanges = action.payload.newValue;
    },
    updateTotalNotif: (state, action) => {
      state.totalNotification = action.payload.newValue;
    },
    addTotalNotif: (state, action) => {
      state.totalNotification = state.totalNotification + action.payload.newValue;
    },
    updateListNotif: (state, action) => {
      state.listNotification = action.payload.newValue;
    },
  },
});

export const { savechanges, updateTotalNotif, addTotalNotif, updateListNotif } =
  oldDataSlice.actions;
export default oldDataSlice.reducer;
